import * as SidebarActions from '../actions/sidebar';

export interface State {
	activeNavigationItem: string;
	activeNavigationMenuItem: string;
	isNavigationExpanded: boolean;
	isAdminSectionExpanded: boolean;
}

export const InitialState: State = {
	activeNavigationItem: null,
	activeNavigationMenuItem: null,
	isNavigationExpanded: false,
	isAdminSectionExpanded: false,
};

export function reducer(state: State = InitialState, action: SidebarActions.All): State {
	switch (action.type) {

		case SidebarActions.ACTIVE_NAVIGATION_ITEM:
			return {...state, activeNavigationItem: action.item};

		case SidebarActions.ACTIVE_NAVIGATION_MENU_ITEM:
			return {...state, activeNavigationMenuItem: action.item};

		case SidebarActions.TOGGLE_NAVIGATION:
			return {...state, isNavigationExpanded: !state.isNavigationExpanded};

		case SidebarActions.OPEN_NAVIGATION:
			return {...state, isNavigationExpanded: true};

		case SidebarActions.CLOSE_NAVIGATION:
			return {...state, isNavigationExpanded: false};

		case SidebarActions.TOGGLE_ADMIN_SECTION:
			return {...state, isAdminSectionExpanded: !state.isAdminSectionExpanded};

		case SidebarActions.OPEN_ADMIN_SECTION:
			return {...state, isAdminSectionExpanded: true};

		case SidebarActions.CLOSE_ADMIN_SECTION:
			return {...state, isAdminSectionExpanded: false};

		default:
			return state;
	}
}

export const GetActiveNavigationItem = (s: State): string => s.activeNavigationItem;
export const GetActiveNavigationMenuItem = (s: State): string => s.activeNavigationMenuItem;
export const IsNavigationExpanded = (s: State): boolean => s.isNavigationExpanded;
export const IsAdminSectionExpanded = (s: State): boolean => s.isAdminSectionExpanded;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/sidebar.ts